const data = {
  pageName: "DigitalPromos",
  paymentCanceled: false,
  errorMsg: "",

  services: {
    digitalPromosProductRecommendation: {
      url: "digitalPromos/queryProductRecommendation",
      params: {}
    },
    digitalPromosProductBundles: {
      url: "digitalPromos/productBundles",
      params: {}
    },
    digitalPromosActivation: {
      url: "digitalPromos/activation",
      params: {}
    },
    translations: {
      url: "digitalPromos/translations",
      params: {}
    }
  }
};

exports.data = data;
